import React from "react";
import { Code2 } from "lucide-react";

/** Read-only "W3Schools-style" display of a course/recording's manual notes:
 * numbered sections with a colored accent rail, and a distinct "Example" code box. */
export function ManualNotesPanel({ notes }) {
  if (!notes || notes.length === 0) {
    return <p className="text-sm text-slate-500" data-testid="manual-notes-empty">The creator hasn't added written notes here yet.</p>;
  }
  return (
    <div className="space-y-6" data-testid="manual-notes-content">
      {notes.map((n, i) => (
        <div key={n.id} className="relative pl-4 border-l-2 border-amber-400/40">
          <span className="absolute -left-[9px] top-0.5 w-4 h-4 rounded-full bg-amber-400 text-background text-[10px] font-bold flex items-center justify-center">{i + 1}</span>
          <h4 className="font-heading text-sm font-semibold text-white mb-1.5">{n.heading}</h4>
          <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-wrap">{n.content}</p>
          {n.code_example && (
            <div className="mt-3 rounded-lg overflow-hidden border border-white/10">
              <div className="flex items-center gap-1.5 bg-white/[0.06] px-3 py-1.5 border-b border-white/10">
                <Code2 className="w-3 h-3 text-emerald-400" />
                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Example</span>
              </div>
              <pre className="bg-black/40 p-3 text-xs text-emerald-300 overflow-x-auto"><code>{n.code_example}</code></pre>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
